import React from 'react'
import { Link } from 'react-router-dom';

const ATCDetails = () => {
    return (
        <>
            <div className="inner-page-banner-area" style={{ backgroundImage: 'url("//images/About_/images/about_banner.jpg")' }}>
                <div className="container">
                    <div className="pagination-area">
                        <h1>Institute Registration Details and Instructions</h1>

                    </div>
                </div>
            </div>

            <div className="courses-page-area2">
                <div className="container" id="inner-isotope">
                    <div className="row mx-auto ">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="isotop-classes-tab isotop-btn ">
                                <ul className='nav justify-content-center align-items-center' role='tablist'>
                                    <li className="nav-item ms-2">
                                        <a className=" active" data-bs-toggle="tab" href="#BasicRegistration" role="tab">Basic Registration Details and Instructions</a>
                                    </li>
                                    <li className="nav-item ms-2">
                                        <a className="" data-bs-toggle="tab" href="#Standard1Registration" role="tab">Standard-I Registration Details and Instructions</a>

                                    </li>
                                    <li className="nav-item ms-2">
                                        <a className="" data-bs-toggle="tab" href="#Standard2Registration" role="tab">Standard-II Registration Details and Instructions</a>

                                    </li>
                                    <li className="nav-item ms-2">
                                        <a className="" data-bs-toggle="tab" href="#PremiumRegistration" role="tab">Premium Registration Details and Instructions</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="">


                    {/* Tab panes */}
                    <div className="tab-content ">

                        <div className="tab-pane active animate " id="BasicRegistration" role="tabpanel">
                            <div className="flex-grow-1 ms-2">

                                <div className="container " >
                                    <div className="row ">
                                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                            <div className="lecturers-contact-info">
                                                <img src="/images/atc-1.jpg" className="img-responsive" alt="team-image" />
                                                <img src="/images/atc-2.jpg" className="img-responsive" alt="team-image" />
                                            </div>
                                        </div>


                                        <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                                            <h3 className="title-default-left title-bar-big-left-close">Basic Registration Details and Instructions</h3>
                                            <ol>
                                                <li>Applicant Organization should read all the instructions and process details before application process.</li>
                                                <li>Applicant Read all <i>Terms, Conditions and Rules </i> before application process.</li>
                                                <li>Read Proper Self Declaration Form</li>
                                                <li>Minimum Distance of ATC 500Mtrs.</li>
                                                <li>Admission Per Month Basis</li>
                                                <li><b>Parlor Institute & Fashion Designer Institute Only <br />(Not for Computer Institute)</b></li>
                                                <li>Registration Fees for <b>Basic Registration Rs. 5000/-</b></li>
                                                <li><b>Payment Method - Through Online Pay From ITT Council website, Cash Transaction Not Valid</b></li>
                                                <li><b><u>Applications are invited from following type -</u></b></li>
                                                <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}>Individuals/Organizations:
                                                </h5>

                                                <ul className='course-feature2'>
                                                    <li>Individuals (Proprietor)</li>
                                                    <li>Partnership Firm</li>
                                                    <li>Private Computer Training Institutes</li>
                                                    <li>Tuition/Coaching Classes</li>
                                                </ul>
                                                <li><b><u>Documents Required :-</u></b></li>
                                                <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Proprietorship :-</b>
                                                </h5>
                                                <ul className='course-feature2' >
                                                    <li>Shop Act License</li>
                                                    <li>Proprietor PAN Card</li>
                                                    <li>Aadhar Card</li>
                                                </ul>
                                                <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Partnership:</b>
                                                </h5>
                                                <ul className='course-feature2'>
                                                    <li>Shop Act License</li>
                                                    <li>Partner PAN Card</li>
                                                    <li>Aadhar Card</li>
                                                    <li>Partnership Deed</li>
                                                </ul>
                                                <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Trust & Society :-</b>
                                                </h5>
                                                <ul className='course-feature2'>
                                                    <li>Shop Act License</li>
                                                    <li>Trust Deed</li>
                                                    <li>Management PAN Card</li>
                                                    <li>Management Aadhar Card</li>
                                                </ul>
                                                <li><b>Photo Required :-</b></li>
                                                <ul className='course-feature2'>
                                                    <li>Applicants Photoe</li>
                                                    <li>Institute Front Photo With Name Board</li>
                                                    <li>Applicant Photo & Signiture Upload</li>
                                                    <li>Management Aadhar Card</li>
                                                </ul>
                                            </ol>
                                            <Link to='/atcregform' className='default-big-btn '> Apply Online</Link>
                                            <Link to='/atcTerms' className='default-big-btn m-1'> T & C</Link>

                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="tab-pane animate" id="Standard1Registration" role="tabpanel">
                            <div className="d-flex">
                                <div className="flex-grow-1 ms-2">
                                    <div className="container   " >
                                        <div className="row ">
                                            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                                <div className="lecturers-contact-info">
                                                    <img src="/images/atc-3.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-4.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-5.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-2.jpg" className="img-responsive" alt="team-image" />


                                                </div>
                                            </div>
                                            <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                                                <h3 className="title-default-left title-bar-big-left-close">Standard-I Registration Details and Instructions</h3>
                                                <ol>
                                                    <li>Applicant Organization should read all the instructions and process details before application process.</li>
                                                    <li>Applicant Read all <i>Terms, Conditions and Rules </i> before application process.</li>
                                                    <li>Read Proper Self Declaration Form</li>
                                                    <li>Minimum Distance of ATC 500Mtrs.</li>
                                                    <li>Admission Per Month Basis</li>
                                                    <li>Computer Institute and Technical Institute For Regular Courses Standard Registration</li>
                                                    <li>Registration Fees for <b>STANDARD-I REGISTRATION Rs. 7500/-</b></li>
                                                    <li><b>Payment Method - Through Online Pay From ITT Council website, Cash Transaction Not Valid</b></li>
                                                    <li><b><u>Applications are invited from following type -</u></b></li>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}>Individuals/Organizations:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Individuals (Proprietor)</li>
                                                        <li>Partnership Firm</li>
                                                        <li>Private Computer Training Institutes</li>
                                                        <li>Tuition/Coaching Classes</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}>Educational Institutes:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Schools</li>
                                                        <li>Junior Colleges</li>
                                                        <li>MBA Colleges</li>
                                                        <li>Engineering Colleges</li>
                                                        <li>ITI</li>
                                                        <li>Polytechnics</li>
                                                    </ul>

                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}> Organizations:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>NGO</li>
                                                        <li> Charitable Trust</li>
                                                        <li>Society</li>
                                                        <li>Self Help Group</li>
                                                    </ul>

                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}> Private Organization:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Financial Institution</li>
                                                        <li>  Company</li>
                                                        <li>IT Entrepreneur</li>
                                                    </ul>
                                                    <li><b><u>Documents Required :-</u></b></li>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Proprietorship :-</b>
                                                    </h5>
                                                    <ul className='course-feature2' >
                                                        <li>Shop Act License</li>
                                                        <li>Proprietor PAN Card</li>
                                                        <li>Aadhar Card</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Partnership:</b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li>Partner PAN Card</li>
                                                        <li>Aadhar Card</li>
                                                        <li>Partnership Deed</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Trust & Society :-</b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li>Trust Deed</li>
                                                        <li>Management PAN Card</li>
                                                        <li>Management Aadhar Card</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Public & Private Ltd. Co. :- </b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li> Certificate of Incorporation</li>
                                                        <li>MOA</li>
                                                        <li>Both Director PAN Card & Adhar Card</li>
                                                    </ul>
                                                    <li><b>Photo Required :-</b></li>
                                                    <ul className='course-feature2'>
                                                        <li>Applicants Photoe</li>
                                                        <li>Institute Front Photo With Name Board</li>
                                                        <li>Applicant Photo & Signiture Upload</li>
                                                        <li>Management Aadhar Card</li>
                                                    </ul>
                                                </ol>
                                                <Link to='/atcregform' className='default-big-btn '> Apply Online</Link>
                                                <Link to='/atcTerms' className='default-big-btn m-1'> T & C</Link>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="tab-pane animate" id="Standard2Registration" role="tabpanel">
                            <div className="d-flex">

                                <div className="flex-grow-1 ms-2">
                                    <div className="container  " >
                                        <div className="row featuredContainer">
                                            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                                <div className="lecturers-contact-info">
                                                    <img src="/images/atc-6.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-1.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-5.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-2.jpg" className="img-responsive" alt="team-image" />


                                                </div>
                                            </div>
                                            <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                                                <h3 className="title-default-left title-bar-big-left-close">Standard-II Registration Details and Instructions</h3>
                                                <ol>
                                                    <li>Applicant Organization should read all the instructions and process details before application process.</li>
                                                    <li>Applicant Read all <i>Terms, Conditions and Rules </i> before application process.</li>
                                                    <li>Read Proper Self Declaration Form</li>
                                                    <li>Minimum Distance of ATC 500Mtrs.</li>
                                                    <li>Admission Per Month Basis</li>
                                                    <li>Standard II Registration for Advance Courses Training Center</li>
                                                    <li>Registration Fees for <b> STANDARD-II REGISTRATION Rs. 11000/-</b></li>
                                                    <li><b>Payment Method - Through Online Pay From ITT Council website, Cash Transaction Not Valid</b></li>
                                                    <li><b><u>Applications are invited from following type -</u></b></li>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}>Individuals/Organizations:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Individuals (Proprietor)</li>
                                                        <li>Partnership Firm</li>
                                                        <li>Private Computer Training Institutes</li>
                                                        <li>Tuition/Coaching Classes</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}>Educational Institutes:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Schools</li>
                                                        <li>Junior Colleges</li>
                                                        <li>MBA Colleges</li>
                                                        <li>Engineering Colleges</li>
                                                        <li>ITI</li>
                                                        <li>Polytechnics</li>
                                                    </ul>

                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}> Organizations:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>NGO</li>
                                                        <li> Charitable Trust</li>
                                                        <li>Society</li>
                                                        <li>Self Help Group</li>
                                                    </ul>

                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}> Private Organization:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Financial Institution</li>
                                                        <li>  Company</li>
                                                        <li>IT Entrepreneur</li>
                                                    </ul>
                                                    <li><b><u>Documents Required :-</u></b></li>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Proprietorship :-</b>
                                                    </h5>
                                                    <ul className='course-feature2' >
                                                        <li>Shop Act License</li>
                                                        <li>Proprietor PAN Card</li>
                                                        <li>Aadhar Card</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Partnership:</b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li>Partner PAN Card</li>
                                                        <li>Aadhar Card</li>
                                                        <li>Partnership Deed</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Trust & Society :-</b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li>Trust Deed</li>
                                                        <li>Management PAN Card</li>
                                                        <li>Management Aadhar Card</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Public & Private Ltd. Co. :- </b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li> Certificate of Incorporation</li>
                                                        <li>MOA</li>
                                                        <li>Both Director PAN Card & Adhar Card</li>
                                                    </ul>
                                                    <li><b>Photo Required :-</b></li>
                                                    <ul className='course-feature2'>
                                                        <li>Applicants Photoe</li>
                                                        <li>Institute Front Photo With Name Board</li>
                                                        <li>Applicant Photo & Signiture Upload</li>
                                                        <li>Management Aadhar Card</li>
                                                    </ul>
                                                </ol>
                                                <Link to='/atcregform' className='default-big-btn '> Apply Online</Link>
                                                <Link to='/atcTerms' className='default-big-btn m-1'> T & C</Link>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="tab-pane animate" id="PremiumRegistration" role="tabpanel">
                            <div className="d-flex mt-2">

                                <div className="flex-grow-1 ms-2">
                                    <div className="container  ">
                                        <div className="row featuredContainer">
                                            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                                <div className="lecturers-contact-info">
                                                    <img src="/images/atc-2.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-6.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-4.jpg" className="img-responsive" alt="team-image" />
                                                    <img src="/images/atc-1.jpg" className="img-responsive" alt="team-image" />


                                                </div>
                                            </div>
                                            <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                                                <h3 className="title-default-left title-bar-big-left-close">Premium Registration Details and Instructions</h3>
                                                <ol>
                                                    <li>Applicant Organization should read all the instructions and process details before application process.</li>
                                                    <li>Applicant Read all <i>Terms, Conditions and Rules </i> before application process.</li>
                                                    <li>Read Proper Self Declaration Form</li>
                                                    <li>Minimum Distance of ATC 500Mtrs.</li>
                                                    <li>Admission Per Month Basis</li>
                                                    <li>Computer Institute with Marketing Support</li>
                                                    <li>Marketing Team Support / Help, Brouchers for 9 Months and 12 Diploma. (2000 Nos)</li>
                                                    <li>1st Courses - <b>Diploma in Information Technology Teacher (D.ITT) - 12 Months Duration</b></li>
                                                    <li>2nd Courses - <b>Diploma in Information Technology Application (D.ITA) - 9 Months Duration</b></li>
                                                    <li>Registration fees for <b>PREMIUM REGISTRATION Rs. 15000/-</b></li>
                                                    <li><b>Payment Method - Through Online Pay From ITT Council website, Cash Transaction Not Valid</b></li>
                                                    <li><b><u>Applications are invited from following type -</u></b></li>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}>Individuals/Organizations:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Individuals (Proprietor)</li>
                                                        <li>Partnership Firm</li>
                                                        <li>Private Computer Training Institutes</li>
                                                        <li>Tuition/Coaching Classes</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}>Educational Institutes:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Schools</li>
                                                        <li>Junior Colleges</li>
                                                        <li>MBA Colleges</li>
                                                        <li>Engineering Colleges</li>
                                                        <li>ITI</li>
                                                        <li>Polytechnics</li>
                                                    </ul>

                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}> Organizations:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>NGO</li>
                                                        <li> Charitable Trust</li>
                                                        <li>Society</li>
                                                        <li>Self Help Group</li>
                                                    </ul>

                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}> Private Organization:
                                                    </h5>

                                                    <ul className='course-feature2'>
                                                        <li>Financial Institution</li>
                                                        <li>  Company</li>
                                                        <li>IT Entrepreneur</li>
                                                    </ul>
                                                    <li><b><u>Documents Required :-</u></b></li>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Proprietorship :-</b>
                                                    </h5>
                                                    <ul className='course-feature2' >
                                                        <li>Shop Act License</li>
                                                        <li>Proprietor PAN Card</li>
                                                        <li>Aadhar Card</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Partnership:</b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li>Partner PAN Card</li>
                                                        <li>Aadhar Card</li>
                                                        <li>Partnership Deed</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Trust & Society :-</b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li>Trust Deed</li>
                                                        <li>Management PAN Card</li>
                                                        <li>Management Aadhar Card</li>
                                                    </ul>
                                                    <h5 className='title-default-left title-bar-big-left-close ' style={{ fontSize: "14px" }}><b>Public & Private Ltd. Co. :- </b>
                                                    </h5>
                                                    <ul className='course-feature2'>
                                                        <li>Shop Act License</li>
                                                        <li> Certificate of Incorporation</li>
                                                        <li>MOA</li>
                                                        <li>Both Director PAN Card & Adhar Card</li>
                                                    </ul>
                                                    <li><b>Photo Required :-</b></li>
                                                    <ul className='course-feature2'>
                                                        <li>Applicants Photoe</li>
                                                        <li>Institute Front Photo With Name Board</li>
                                                        <li>Applicant Photo & Signiture Upload</li>
                                                        <li>Management Aadhar Card</li>
                                                    </ul>
                                                </ol>
                                                <Link to='/atcregform' className='default-big-btn '> Apply Online</Link>
                                                <Link to='/atcTerms' className='default-big-btn m-1'> T & C</Link>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* end card-body */}
                    {/* end card */}

                </div>
            </div>



        </>
    )

}

export default ATCDetails;